export default import.meta.ROLLUP_FILE_URL_Nn7iCj6wCSmagcInGB7Yqg